export const defaultSettings = {
  brandName: 'OmsorgBygg.no',
  heroTitle: 'Trygge boliger og bygg til leie – fra en utleier du kan stole på.',
  heroDescription:
    'OmsorgBygg eier og leier ut boliger og omsorgsbygg over hele landet. Vi legger vekt på god standard, ryddige leieforhold og en enkel prosess for deg som leter etter riktig bolig.',
  highlights: [
    'Oversikt over ledige boliger og bygg til leie',
    'Tydelig informasjon om adresse, størrelse, leie og tilgjengelighet',
    'Personlig oppfølging gjennom hele leieforholdet',
  ],
  portfolioStats: [
    { label: 'Eiendommer i porteføljen', value: '15' },
    { label: 'Steder i Norge', value: '14' },
    { label: 'Ledige nå', value: '08' },
  ],
  propertyTypes: [
    {
      title: 'Omsorgsboliger',
      description:
        'Boliger tilrettelagt for trygg, langsiktig drift med god tilgjengelighet og kort vei til tjenester og kollektivtilbud.',
    },
    {
      title: 'Leilighetsbygg',
      description:
        'Moderne boenheter for leietakere som ønsker sentral beliggenhet, forutsigbar standard og enkel adkomst.',
    },
    {
      title: 'Kombinasjonsbygg',
      description:
        'Eiendommer som kombinerer boliger, fellesarealer og funksjoner – godt egnet for både offentlig og privat drift.',
    },
  ],
};

export const emptyPropertyForm = {
  name: '',
  address: '',
  type: 'Hus',
  size: '',
  rentPerMonth: '',
  rooms: '',
  availableFrom: '',
  status: '',
  availability: 'ledig',
  facilities: [],
  summary: '',
  imageUrl: '',
  images: [],
};